module.exports = __webpack_public_path__ + "media/16/down-arrow-69d8d1a2.svg";